const blogPosts = [
  {
    slug: 'ai-driven-innovation',
    title: 'AI-Driven Innovation for Modern Businesses',
    excerpt:
      'Explore how AI and automation unlock new efficiency for growing organizations, from smarter workflows to intelligent customer experiences crafted by VAISPtech.',
    date: 'January 12, 2025',
    author: 'VAISPtech Team',
    readTime: '6 min read',
    imageGradient: 'from-indigo-600 via-purple-500 to-blue-500',
    content: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vitae fermentum urna. Nulla facilisi. Phasellus nec suscipit nisl. Maecenas laoreet tristique sapien, a semper orci volutpat a.',
      'Integer posuere risus vel risus mollis, sed fermentum nibh cursus. Vivamus tincidunt lorem in sapien fermentum, vel sagittis ligula interdum. Cras eleifend massa vel dui commodo, quis tincidunt turpis fringilla.',
      'Suspendisse fermentum viverra orci, vitae malesuada mi dignissim in. Aliquam tristique placerat ultricies. Sed tempus mi sed metus feugiat, sed consequat tellus vulputate. Vivamus lacus leo, efficitur non lacinia id, lobortis sit amet nibh.'
    ]
  },
  {
    slug: 'building-secure-digital-products',
    title: 'Building Secure Digital Products from Day One',
    excerpt:
      'Security-first development keeps your product safe and resilient. Learn the foundational practices our team uses to protect user trust and data.',
    date: 'February 4, 2025',
    author: 'VAISPtech Engineering',
    readTime: '7 min read',
    imageGradient: 'from-purple-700 via-indigo-600 to-slate-800',
    content: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent porttitor lacus ac ligula bibendum, vitae porta risus efficitur. Curabitur venenatis, sapien at feugiat laoreet, quam enim laoreet ligula, in pretium felis diam ac est.',
      'Duis aliquam, ligula et imperdiet venenatis, dolor risus cursus nunc, quis luctus odio tortor vitae dui. Curabitur tristique augue nec eros faucibus, in varius odio pharetra.',
      'Etiam vestibulum vestibulum erat, vel elementum enim consequat ut. Integer fringilla lectus sed ultrices vestibulum. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.'
    ]
  },
  {
    slug: 'future-of-digital-experiences',
    title: 'Designing the Future of Digital Experiences',
    excerpt:
      'Great design blends storytelling and technology. Discover how a creative strategy backed by human-centered design elevates every touchpoint.',
    date: 'March 18, 2025',
    author: 'Creative Studio',
    readTime: '5 min read',
    imageGradient: 'from-fuchsia-600 via-purple-500 to-indigo-500',
    content: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla varius dui et magna tristique, vitae facilisis massa consectetur. Vivamus quis leo aliquet, fermentum nibh ut, hendrerit nibh.',
      'Sed pellentesque posuere magna, eget laoreet justo congue et. Maecenas suscipit malesuada leo ut fermentum. Proin luctus tellus id consectetur scelerisque.',
      'Suspendisse quis tortor sed nisi mollis viverra. Nulla volutpat metus non justo volutpat, non auctor purus vehicula. Pellentesque et consequat ligula.'
    ]
  },
  {
    slug: 'automation-success-stories',
    title: 'Automation Success Stories from VAISPtech Clients',
    excerpt:
      'AI-powered automation delivers measurable impact. We share highlights from client journeys that transformed operations and customer engagement.',
    date: 'April 2, 2025',
    author: 'Client Success Team',
    readTime: '8 min read',
    imageGradient: 'from-blue-700 via-indigo-600 to-purple-700',
    content: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque egestas magna magna, sed cursus lorem venenatis sit amet. Fusce ac ipsum ac quam pharetra dapibus.',
      'Integer dictum, lectus eget auctor tempus, massa massa sagittis nibh, at finibus purus magna a dui. Quisque nisl elit, congue id elit et, ultrices semper velit.',
      'Nam sit amet velit id dui condimentum congue. Vestibulum convallis lectus vitae tellus dictum, at aliquam tellus interdum. Curabitur ac nisi sed turpis imperdiet facilisis.'
    ]
  }
];

export default blogPosts;
